import { useLanguage } from "@hooks/use-language";
import { AccountSettingsDropdown } from "@pages/account-settings/account-settings-dropdown";

/**
 * A simple Language dropdown.
 * When opened the user can chose between the available languages
 * and select to which one the Dashboard should be translated to.
 */
export function AccountLanguageSelector(): JSX.Element {
  const { supportedLanguages, updateLanguage, currentLanguage } = useLanguage();

  const languageItems = supportedLanguages
    .map((language) => {
      return {
        value: language.code,
        label: language.name,
      };
    })
    .sort((a, b) => a.value.localeCompare(b.value));

  return (
    <AccountSettingsDropdown
      items={languageItems}
      selectedItem={{
        label: currentLanguage.name,
        value: currentLanguage.code,
      }}
      onClickHandler={(code) => updateLanguage("account settings", code)}
    />
  );
}
